import {
    useMemo,
} from 'react'
import CloudDoneIcon from '@mui/icons-material/CloudDone'
import CloudOffIcon from '@mui/icons-material/CloudOff'
import useStyles from './CloudIconBoolean.style'

export default function CloudIconBoolean({
    value,
}: Readonly<{
    value: boolean,
}>) {
    const {
        classes,
    } = useStyles()

    const icon = useMemo(() => {
        return value
            ? <CloudDoneIcon className={classes.cloudDoneIcon} />
            : <CloudOffIcon className={classes.cloudOffIcon} />
    }, [
        classes.cloudDoneIcon,
        classes.cloudOffIcon,
        value,
    ])

    return <div className={classes.iconWrapper}>{icon}</div>
}
